export enum OrderQueries {
	GET_COMPANY_ORDERS = `
    query CompanyOrders ($companyId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!, $filters: OrdersListFiltersInput!) {
        companyOrders(
            companyId: $companyId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
            filters: $filters
        ) {
            nodes {
                total
                orders {
                    photographerPersonId
                    photographerFullName
                    orderId
                    orderNumber
                    orderStatusId
                    orderStatusName
                    dueDate
                    creationDate
                    completitionDate
                    approvedShots
                    totalShots
                }
            }
        }
    }
    `,
    GET_COMPANY_ORDER_INFO = `
    query CompanyOrderInfo($companyId: Int!, $orderId: Int!) {
        companyOrderInfo(companyId: $companyId, orderId: $orderId) {
            nodes {
                orderId
                statusId
                statusName
                completitionDate
                creationDate
                dueDate
                notes
                photographerId
                photographerName
            }
        }
    }
    `,
	GET_COMPANY_ORDER_DETAILS = `
    query CompanyOrderDetails($companyId: Int!, $orderId: Int!) {
        companyOrderDetails(companyId: $companyId, orderId: $orderId) {
            nodes {
                orderStatusId
                warehouse {
                    warehouseId
                    warehouseCode
                    warehouseDescription
                    warehouseFullName
                }
                orderDetails {
                    orderId
                    orderStyleId
                    modelId
                    styleCode
                    styleName
                    sizeGroupId
                    sizeGroupName
                    shots {
                        modelId
                        colorId
                        colorName
                        sizeGroupId
                        sizeGroupName
                        orderId
                        orderStyleId
                        brandId
                        categoryId
                        templateId
                        shotTypeId
                        shotType
                        aspectRatioId
                        aspectRatio
                        mediaFormatId
                        mediaFormat
                        codifiedUsedId
                        codifiedUsed
                        shotId
                        shotApprovalStatusId
                        imgPath
                    }
                }
            }
        }
    }
    `,
	GET_ORDER_STATUSES_NO_IDS = `
    query OrderStatuses($companyId: Int!) {
        orderStatuses(companyId: $companyId) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_ORDER_STATUSES = `
    query OrderStatuses($companyId: Int!, $ids: [Int]) {
        orderStatuses(companyId: $companyId, where: { id: { in: $ids } }) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_WAREHOUSES_NO_IDS = `
    query Warehouses($first: Int, $after: String, $search: String, $companyId: Int!) {
        warehouses(
            first: $first, after: $after, 
            companyId: $companyId,
            where: { or: [{code: { contains: $search }}, {description: { contains: $search }}]
            }
            order: { code: ASC, description: ASC }
        ) {
            nodes {
                code
                description
                id
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
    GET_SHOTS = `
    query Shots($modelId: Int!, $colorIds: [Int!]!, $brandId: Int!, $categoryId: Int!, $companyId: Int!) {
        shots(
            modelId: $modelId
            colorIds: $colorIds
            brandId: $brandId
            categoryId: $categoryId
            companyId: $companyId
        ) {
            modelId
            styleCode
            styleName
            colorId
            colorName
            sizeGroupId
            sizeGroupName
            shotTypeId
            shotTypeCode
            shotTypeName
            aspectRatioId
            aspectRatioCode
            aspectRatioName
            codifiedUsedId
            codifiedUsedCode
            codifiedUsedName
            mediaFormatId
            mediaFormatCode
            mediaFormatName
            defaultColor
            imgPath
            shotId
        }
    }
    `
}

